import _ from "lodash";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { DRAFT_ACTIONS } from "../components/draft/draftReducer";
import DraftDispatchContext from "../contexts/draftDispatchContext";

export default function useDraftCountdownClock(endDate) {
  const draftDispatch = useContext(DraftDispatchContext);
  const [clock, setClock] = useState(null);

  useEffect(() => {
    let diff;
    let interval;

    if (endDate) {
      interval = setInterval(() => {
        const now = moment();
        const end = moment(endDate);
        diff = end.diff(now);

        setClock(Math.max(Math.floor(diff / 1000), 0));
        draftDispatch({
          type: DRAFT_ACTIONS.SET_INFO,
          payload: {
            propName: "timeIsRunningOut",
            value: clock <= 10,
          },
        });

        console.log("clock", clock);
      }, 1000);
    }

    return () => {
      clearInterval(interval);
    };
  }, [endDate, draftDispatch, clock]);

  const formatClock = () => {
    if (!_.isNumber(clock)) return clock;
    const minutes = Math.floor(clock / 60);
    const seconds = clock - minutes * 60;

    return `${minutes}:${_.padStart("" + seconds, 2, "0")}`;
  };

  return { seconds: clock, formatted: formatClock() };
}
